<template>
    <div class="w-full mx-auto px-1 overflow-hidden overflow-y-auto">
        <!-- Panel superior -->
        <div class="w-full mx-auto  bg-white shadow-sm  px-4 py-1 rounded-md border border-costeaPrimaryDisabled mt-6">
    <!-- Costo CIF (arriba) -->
    <div class=" mb-4 justify-start flex flex-col py-3">
        <span class=" block text-sm "> Gastos de admon y ventas </span>
        
        <span :class="{ skeleton: !dataListo }" class=" block text-2xl font-semibold ">$ {{ interNumberFormat(this.calcCostoTotal) }}</span>
    </div>

    <!-- Fila inferior (inputs y resultados) -->
    <div class="grid grid-cols-12 items-center gap-4 justify-center">
        <!-- total unidades -->
        <div class="col-span-4">
            <label for="total_productos" class=" block text-xs text-gray-500 mb-1"> Total de Unidades / Servicios vendidos por mes </label>
            <input 
                id="total_productos"
                type="number"
                min="0"
                max="99999"
                step="0.01"
                v-model="total_productos"
                :disabled="!dataListo"
                @change="isVisible = true"
                :class="{ skeleton: !dataListo }"
                class=" w-full bg-gray-50  rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-costeaPrimary"
            />
        </div>
        
        <button @click="() => { isVisible = false; addAdmonCalc(); }" v-show="isVisible" type="button"
                class=" col-span-1 ring-4 ring-costeaPrimaryDisabled ring-opacity-30 mx-4 cursor-pointer bg-costeaPrimaryDisabled text-costeaPrimary hover:bg-costeaPrimary hover:text-white rounded-full w-5 h-5 flex justify-center items-center"><i
                    class="ri-check-fill"></i></button>

        <!-- Costo CIF por producto -->
        <div class="col-span-3 text-center">
            <span class="block text-xs text-gray-500">Gastos de Admon y Ventas por producto</span>
            <span :class="{ skeleton: !dataListo }" class=" block text-lg font-bold ">
                $ {{ calcCostoTotal && total_productos > 0 ? interNumberFormat((calcCostoTotal / total_productos ).toFixed(2)) : '0.00' }}
            </span>
        </div>
    </div>
</div>
  
        <!-- Tabla dentro del acordeón -->
        <div class="mt-6">
            <button
    @click="toggleAccordion"
    class="w-full bg-white py-2 px-4 rounded border border-costeaPrimaryDisabled flex justify-between items-center text-gray-700"
  >
    <span> {{ isAccordionOpen ? 'Ocultar detalle' : 'Ver detalle' }} </span>
    <div class="bg-costeaPrimaryDisabled flex justify-center align-center rounded-full p-2" >
        <svg
        
          :class="{ 'rotate-180': isAccordionOpen }"
          class="w-4 h-4  transition-transform duration-200 text-blue-500 ${}"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
          
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
    </div>
  </button>
            <transition name="fade">
                <div v-show="isAccordionOpen">
                    <table class="w-full mt-4 overflow-y-auto">
                        <thead class="font-costea text-t12 border-b-2 pb-3 h-10 text-left">
                            <tr>
                                <th></th>
                                <th><span class="mr-4 cursor-pointer text-costeaDarkGray">Nombre del Gasto</span></th>
                                <th><span class="cursor-pointer text-costeaDarkGray">Gasto mensual</span></th>
                            </tr>
                        </thead>
                        <tbody v-for="gasto in gastos " :key="gasto.index" class="">
                            <tr class="font-costea text-t12 pb-3 h-14">
                                <td></td>
                                <td class="mr-4"><input disabled :value="gasto.nombre_gasto" class="bg-white border-gray-100 border-b-2 w-full text-t12 font-costea text-costeaDarkGray py-2 px-2"/></td>
                                <td class="text-right"><input disabled :value="interNumberFormat(gasto.gasto_mensual)" class="bg-white border-gray-100 border-b-2 w-full text-t12 font-costea text-costeaDarkGray py-2 px-2"/></td>
                            </tr>
                        </tbody>  
                        <tbody v-for="cif in addCif" :key="cif.index">
                            <Cif @removeCif="removeCifHandler" @reloadData="reloadData"/>
                        </tbody>
                    </table>
                </div>
            </transition>
        </div>
    </div>
  </template>
  
  <script>
  import Cif from '@/components/productos/Cif/AddCif.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
      name: "CostoCIF",
      components: {
          Cif,
      },
      data: function() {
          return {
              nums: [1, 2, 3, 4],
              selectedDate: '',
              adicional: false,
              date: new Date(),
              addCif: 0,
              gastoByProducts: [],
              listaGastos: [],
              productDataAdmon: [],
              productDataCif: [],
              productData: [],
              productMod: [],
              total_productos: 0,
              isVisible: false,
              gastos: [],
              isAccordionOpen: false,
              dataListo: false,
          }
      },
      computed: {
          ...mapState(['costea']),
          calcCostoTotal() {
              var suma = 0
              this.gastos.forEach(gasto => {
                  suma += parseInt(gasto.gasto_mensual)
              });
              return suma
          },
          
          defineTotalProductos() {
              var total
              total = this.total_productos;
              return total
          },

      },
      methods: {
          toggleAccordion() {
              this.isAccordionOpen = !this.isAccordionOpen;
          },
          getGastos: function() {
              axios
                  .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}gastos`)
                  .then(respuesta => {
                      this.gastos = respuesta.data;
                      this.dataListo = true;
                      console.log(this.cifs)
                      this.getGastosById(this.gastos[0].id)
                  }).catch((error) => {
                      if (error) {
                          if (error.status === 401) {
                              this.$router.push('/login')
                          }
                      }
                  })
          },
          getGastosById: function(id) {
              axios
                  .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}gastos-view/${id}`)
                  .then(respuesta => {
                      
                      console.log(respuesta.data)
                  }).catch((error) => {
                      if (error) {
                          if (error.status === 401) {
                              this.$router.push('/login')
                          }
                      }
                  })
          },
          addAdmonCalc() {
              axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/add-admon-calc/${this.$route.params.id}`, { total_productos: parseFloat(this.defineTotalProductos) })
                  .then((response) => {
                          console.log(response)
                          this.reloadData(true)
                      }
                  ).catch(error => console.log(error));
          },
  
          interNumberFormat(number) {
              let interNF = new Intl.NumberFormat('es-CO');
              let numberDecimals = parseFloat(number)
              numberDecimals = numberDecimals.toFixed(2)
              return interNF.format(numberDecimals)
          },
          removeGastoHandler(value) {
              this.addGasto += value
          },
          getDataToGasto() {
              axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
                  .then(
                      response => {
                          this.productDataCif = response.data.data.cifcostos;
                          this.productDataAdmon = response.data.data.admongastos;
                          this.productMod = response.data.data.modirectas;
                          this.productData = response.data.data;
                          this.total_productos = response.data.data.total_productos;
                          this.tiempo_standar = response.data.data.tiempo_standar;
                      }
                  ).catch(
                      error => {
                          console.log(error)
                      }
                  );
              axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod`)
                  .then(
                      response => {
                          this.costo_hora_hombre_cif = response.data;
                          console.log('producto Hora Hombre CIF')
                          console.log(this.costo_hora_hombre_cif);
                      }
                  ).catch(
                      error => {
                          console.log(error);
                      }
                  )
          },
          getGastosByProducts() {
              axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
                  .then(response => {
                      this.gastoByProducts = response.data.data.admongastos
                  })
                  .catch(error => console.log(error))
          },
          getGastoDetails() {
              axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}gastos`)
                  .then(
                      response => {
                          this.listaGastos = response.data
                      }
                  ).catch(
                      error => console.log(error)
                  )
          },
          reloadData(value) {
              if (value === true) {
                  this.getGastosByProducts()
                  this.getGastoDetails()
                  this.$emit('reloadData', true)
                  value = false
              } else {
                  console.log('Ocurrio un error')
              }
          },
          filterGastoList(id) {
              let data
              data = this.listaGastos.find(gasto => { return gasto.id == id })
              return data
          },
      },
      created() {
          this.getGastosByProducts(),
          this.getGastoDetails()
          this.calcCostoTotal
          this.getDataToGasto()
          this.getGastos()
      },
  }
  </script>
  
  <style>
  th {
      height: 40px;    
  }
  td {
      margin: 10px 0px;
  }
  .container {
      padding: 4px 16px;
      border-radius: 8px;
      border: 1px solid #dbdeec;
      margin-top: 24px;
      display: flex;
      align-items: center;
  }

  .skeleton {
  position: relative;
  width: 100%;
  /* Ancho del skeleton */
  height: auto;
  /* Altura del skeleton */
  overflow: hidden;
  /* Oculta el desbordamiento del pseudo-elemento */
  color: transparent
}

.skeleton::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f2f2f2;
    animation: skeleton-loading 1s infinite ease-in-out;
    pointer-events: none; /* Evita que el pseudo-elemento bloquee las interacciones */
    z-index: 1; /* Asegura que el pseudo-elemento quede por encima del fondo, pero no del contenido */
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.7;
    /* Opacidad inicial del skeleton */
  }

  50% {
    opacity: 0.4;
    /* Opacidad intermedia del skeleton */
  }

  100% {
    opacity: 0.7;
    /* Opacidad final del skeleton */
  }
}
.rotate-180 {
  transform: rotate(180deg);
}
  </style>
  